import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import {
	CalendarIcon,
	ChartBarIcon,
	HomeIcon,
	UsersIcon,
	XIcon,
	CollectionIcon,
	TicketIcon,
	StarIcon,
	ClipboardListIcon,
	QuestionMarkCircleIcon,
	MailIcon,
	SpeakerphoneIcon,
	CogIcon,
	LibraryIcon,
	IdentificationIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	ClipboardCheckIcon,
	LocationMarkerIcon,
	} from '@heroicons/react/outline'
import logo from '../../images/logo-pc-white.png'
import tools from '../../tools'

const ChatBubbleLeftRightIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
		<path strokeLinecap="round" strokeLinejoin="round" d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155" />
	</svg>
)

class SidebarTailwind extends Component {
	constructor(props) {
		super(props)
		this.state = {
			sidebarOpen : false,
			navigation: [],
			url: null
		}
		const permissions = this.props.user.permissions
		if (permissions && permissions.homepage && permissions.homepage % 2 === 1)
			this.state.navigation.push({ name: 'Dashboard', path: '/', icon: HomeIcon, current: true, display: false, collapse: null })
		if (permissions && permissions.precheckins && permissions.precheckins % 2 === 1)
		{
			this.state.navigation.push({
				name: 'Pré-checkins',
				path: '/checkins/arrivals',
				icon: IdentificationIcon,
				current: false,
				display: false,
				collapse: [
					{ collapseName: 'Planning des arrivées', path: '/checkins/arrivals', current: false },
					{ collapseName: 'Cautions SWIKLY', path: '/deposit/users-deposit', current: false }
				]
			})
		}
		if (permissions && permissions.interventions && permissions.interventions % 2 === 1)
		{
			this.state.navigation.push({
				name: 'Interventions',
				path: '/interventions',
				icon: ClipboardCheckIcon,
				current: false,
				display: false,
				collapse: null
			})
		}
		// Emplacements (décision 8) : la consultation par hébergement selon les droits interventions ou
		// inventaires, et le paramétrage (ancien Paramètres > Emplacements) avec le droit Paramètres
		const canSeeLocations = !!permissions && ((permissions.interventions && permissions.interventions % 2 === 1) || (permissions.inventories && permissions.inventories % 2 === 1))
		const canSetLocations = !!permissions && permissions.params && permissions.params % 2 === 1
		if (canSeeLocations || canSetLocations)
		{
			const locationsCollapse = []
			if (canSeeLocations)
				locationsCollapse.push({ collapseName: 'Plan et fiches', path: '/emplacements', current: false })
			if (canSetLocations)
				locationsCollapse.push({ collapseName: 'Paramétrage', path: '/emplacements/parametrage', current: false })
			this.state.navigation.push({ name: 'Emplacements', path: locationsCollapse[0].path, icon: LocationMarkerIcon, current: false, display: false, collapse: locationsCollapse })
		}
		if (permissions && permissions.rubrics && permissions.rubrics % 2 === 1)
		{
			this.state.navigation.push({
				name: 'Livret d\'accueil',
				path: '/contenu',
				icon: CollectionIcon,
				display: false,
				collapse: [
					{ collapseName: 'Contenu de mon app ✨', path: '/contenu', current: false },
					{ collapseName: 'Page d\'accueil', path: '/modules', current: false },
					{ collapseName: 'Mes rubriques', path: '/rubriques', current: false },
					{ collapseName: 'Fichiers', path: '/pdf', current: false }
				]
			})
		}
		if (permissions && permissions.activities && permissions.activities % 2 === 1)
		{
			this.state.navigation.push({
				name: 'Activités',
				path: '/animations',
				icon: CalendarIcon,
				display: false,
				collapse: [
					{ collapseName: 'Mes activités', path: '/animations', current: false },
					{ collapseName: 'Planning', path: '/animation-dates', current: false },
					{ collapseName: 'Catégories d\'activité', path: '/animation-categories', current: false }
				]
			})
		}
		if (permissions && permissions.services && permissions.services % 2 === 1)
		{
			this.state.navigation.push({
				name: 'Services',
				path: '/services',
				icon: TicketIcon,
				display: false,
				collapse: [
					{ collapseName: 'Mes services',  path: '/services', current: false },
					{ collapseName: 'Inscriptions',  path: '/services/booking', current: false },
					{ collapseName: 'Commandes',  path: '/services/commandes', current: false }
				]
			})
		}
		if (permissions && permissions.users && permissions.users % 2 === 1)
		{
			this.state.navigation.push({
				name: 'Utilisateurs',
				path: '/utilisateurs',
				icon: UsersIcon,
				current: false,
				display: false,
				collapse: null
			})
		}
		if (permissions && permissions.reviews && permissions.reviews % 2 === 1)
		{
			this.state.navigation.push({
				name: 'Avis clients',
				path: '/avis/formulaires',
				icon: StarIcon,
				display: false,
				collapse: [
					{ collapseName: 'Mes questionnaires',  path: '/avis/formulaires', current: false },
					{ collapseName: 'Avis récoltés',  path: '/avis/reponses', current: false }
				]
			})
		}
		if (permissions && permissions.stats && permissions.stats % 2 === 1)
			this.state.navigation.push({ name: 'Statistiques', path: '/stats', icon: ChartBarIcon, current: false, display: false, collapse: null })
		if (permissions && permissions.emails && permissions.emails % 2 === 1)
		{
			this.state.navigation.push({
				name: 'Email',
				path: '/administration/emails',
				icon: MailIcon,
				current: false,
				display: false,
				collapse: [
					{ collapseName: 'Templates d\'Email',  path: '/administration/emails', current: false },
					{ collapseName: 'Campagnes envoyées',  path: '/administration/auto-email', current: false }
				]
			})
		}
		if (permissions && permissions.inventories && permissions.inventories % 2 === 1)
		{
			this.state.navigation.push({
				name: 'Inventaires',
				path: '/inventaires',
				icon: ClipboardListIcon,
				current: false,
				display: false,
				collapse: [
					{ collapseName: 'Mes hébergements',  path: '/inventaires', current: false },
					{ collapseName: 'Inventaires',  path: '/inventaires/checkin', current: false },
					{ collapseName: 'Inventaires terrain',  path: '/inventaires-terrain', current: false }
				]
			})
		}
		if (permissions && permissions.emails && permissions.emails % 2 === 1)
			this.state.navigation.push({ name: 'Messagerie', path: '/messages/chat', icon: ChatBubbleLeftRightIcon, current: false, display: false, collapse: null })
		if (permissions && permissions.notifications && permissions.notifications % 2 === 1)
			this.state.navigation.push({ name: 'Notifications', path: '/administration/notifications', icon: SpeakerphoneIcon, current: false, display: false, collapse: null })
		if (permissions && permissions.params && permissions.params % 2 === 1)
			this.state.navigation.push({ name: 'Paramètres', path: '/administration/parametres', icon: CogIcon, current: false, display: false, collapse: null })
		// if (this.props.user.limited === true)
		// {
		// 	this.state.navigation = [
		// 		{ name: 'Dashboard', path: '/', icon: HomeIcon, current: true, display: false, collapse: null },
		// 		{ name: 'Inventaires', path: '/inventaires', icon: ClipboardListIcon, current: false, display: false, collapse: 
		// 			[
		// 				{ collapseName: 'Inventaires',  path: '/inventaires/checkin', current: false },
		// 			]	 
		// 		}
		// 	]
		// }
		for (let i = 0; i < this.state.navigation.length; i++)
		{
			this.state.navigation[i].current = false
			this.state.navigation[i].current = null
		}
		this.userNavigation = [
			// { name: 'Votre profil', path: '#' },
  			{ name: 'Mon compte', path: '/parametres', onclick: null },
  			{ name: 'Se déconnecter', path: '#', onclick: this.props.updateUser.bind(this, null) },
		]
	}

	componentDidUpdate()
	{
		if (this.state.url !== window.location.href)
		{
			const navigation = tools.clone(this.state.navigation)
			for (let i = 0; i < this.state.navigation.length; i++)
			{
				switch (navigation[i].name)
				{
					case 'Dashboard':
						navigation[i].icon = LibraryIcon
						break
					case 'Livret d\'accueil':
						navigation[i].icon = CollectionIcon
						break
					case 'Activités':
						navigation[i].icon = CalendarIcon
						break
					case 'Services':
						navigation[i].icon = TicketIcon
						break
					case 'Utilisateurs':
						navigation[i].icon = UsersIcon
						break
					case 'Avis clients':
						navigation[i].icon = StarIcon
						break
					case 'Statistiques':
						navigation[i].icon = ChartBarIcon
						break
					case 'Inventaires':
						navigation[i].icon = HomeIcon
						break
					case 'Pré-checkins':
						navigation[i].icon = IdentificationIcon
						break
					case 'Interventions':
						navigation[i].icon = ClipboardCheckIcon
						break
					case 'Emplacements':
						navigation[i].icon = LocationMarkerIcon
						break
					case 'Messagerie':
						navigation[i].icon = ChatBubbleLeftRightIcon
						break
					case 'Email':
						navigation[i].icon = MailIcon
						break
					case 'Notifications':
						navigation[i].icon = SpeakerphoneIcon
						break
					case 'Paramètres':
						navigation[i].icon = CogIcon
						break
					default:
						navigation[i].icon = QuestionMarkCircleIcon
				}
				const url = window.location.href
				let parsedUrl = new URL(url).pathname
				// une sous-page (/interventions/<id>) garde sa rubrique du menu active
				const onPage = parsedUrl === navigation[i].path || (navigation[i].path !== '/' && parsedUrl.indexOf(navigation[i].path + '/') === 0)
				if (onPage && navigation[i].collapse === null)
					navigation[i].current = true
				else if (!onPage)
					navigation[i].current = false
				if (navigation[i].collapse)
				{
					for (let j = 0; j < navigation[i].collapse.length; j++)
					{
						if (parsedUrl === navigation[i].collapse[j].path)
							navigation[i].collapse[j].current = true
						else if (parsedUrl !== navigation[i].collapse[j].path)
							navigation[i].collapse[j].current = false
					}
				}
			}
			this.setState({ navigation: navigation, url: window.location.href })
		}
	}

	classNames = (...classes) => {
		return classes.filter(Boolean).join(' ')
	}

	setSidebarOpen = () => {
		if (this.state.sidebarOpen === true)
			this.setState({ sidebarOpen: false })
		else
			this.setState({ sidebarOpen: true })
	}

	handleCollapse = (id) => {
		const navigation = this.state.navigation 
		if (navigation[id].display === false)
			navigation[id].display = true
		else
			navigation[id].display = false
		this.setState({ navigation: navigation })
	}

	render() {
		let sidebarOpen = this.state.sidebarOpen
		const user = this.props.user
		let userAvatar = (
			<span className="inline-block h-10 w-10 rounded-full overflow-hidden bg-gray-100">
				<svg className="h-full w-full text-gray-400" fill="currentColor" viewBox="0 0 24 24">
					<path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
				</svg>
			</span>)
		if (user.avatar)
		{
			userAvatar = ( 
				<img
					className="inline-block h-10 w-10 rounded-full"
					src={user.avatar}
					alt="avatar"
				/>)
		}
		return (
			<div>
				<Transition.Root show={sidebarOpen} as={Fragment}>
					<Dialog as="div" className="fixed inset-0 flex z-40 lg:hidden" onClose={this.setSidebarOpen}>
						<Transition.Child
							as={Fragment}
							enter="transition-opacity ease-linear duration-300"
							enterFrom="opacity-0"
							enterTo="opacity-100"
							leave="transition-opacity ease-linear duration-300"
							leaveFrom="opacity-100"
							leaveTo="opacity-0"
						>
              				<Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
           				</Transition.Child>
						<Transition.Child
							as={Fragment}
							enter="transition ease-in-out duration-300 transform"
							enterFrom="-translate-x-full"
							enterTo="translate-x-0"
							leave="transition ease-in-out duration-300 transform"
							leaveFrom="translate-x-0"
							leaveTo="-translate-x-full"
						>
              				<div className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-gray-800">
								<Transition.Child
									as={Fragment}
									enter="ease-in-out duration-300"
									enterFrom="opacity-0"
									enterTo="opacity-100"
									leave="ease-in-out duration-300"
									leaveFrom="opacity-100"
									leaveTo="opacity-0"
								>
									<div className="absolute top-0 right-0 -mr-12 pt-2">
										<button
											type="button"
											className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
											onClick={() => this.setSidebarOpen(false)}
										>
											<span className="sr-only">Close sidebar</span>
											<XIcon className="h-6 w-6 text-white" aria-hidden="true" />
										</button>
									</div>
                				</Transition.Child>
								<div className="flex-shrink-0 flex items-center px-4">
									<img
										className="h-8 w-auto"
										src={logo}
										alt="Workflow"
									/>
								</div>
								<div className="mt-5 flex-1 h-0 overflow-y-auto" style={{ backgroundColor: '#1F2937'}}>
                 					<nav className="px-2 space-y-1 shadow-none" style={{ backgroundColor: '#1F2937'}}>
										{this.state.navigation.map((item, navigation_k) => {
											let collapse = null
											if (item.collapse)
											{
												let collapseStyle = "hidden"
												if (this.state.navigation[navigation_k].display === true)
													collapseStyle = "block"
												collapse = this.state.navigation[navigation_k].collapse.map((elem, collapse_k) => {
													return (
														<div key={collapse_k} className={collapseStyle}>
															<Link
																to={elem.path}
																className={this.classNames(		
																elem.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
																'group flex items-center pl-12 py-2 text-base font-medium rounded-md'
																)}
															>
																{elem.collapseName}
															</Link>
														</div>
													)
												})
												return (
													<div key={navigation_k}>
														<li
															onClick={this.handleCollapse.bind(this, navigation_k)}
															className={this.classNames(		
															item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
															'group flex relative items-center px-3 py-2 text-base font-medium rounded-md'
															)}
														>
															<item.icon
																className={this.classNames(
																	item.current ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-300',
																	'mr-3 flex-shrink-0 h-6 w-6'
																)}
																aria-hidden="true"
															/>
															{item.name}
															<svg
																className={this.classNames(
																	(collapseStyle === "block") ? 'text-gray-400 rotate-90' : 'text-gray-300',
																	'ml-3 flex-shrink-0 absolute right-4 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150'
																	)}
																	viewBox="0 0 20 20"
																	aria-hidden="true"
															>
																<path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
															</svg>
														</li>
														{collapse}
													</div>
												)
											}
											else 
											{
												return (
													<div key={navigation_k}>
														<Link
															to={item.path}
															className={this.classNames(
															item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
															'group flex items-center px-2 py-2 text-base font-medium rounded-md'
															)}
														>
															<item.icon
																className={this.classNames(
																	item.current ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-300',
																	'mr-4 flex-shrink-0 h-6 w-6'
																)}
																aria-hidden="true"
															/>
															{item.name}
															{item.name === 'Messagerie' && this.props.unread_messages > 0 && (
																<span className="ml-auto inline-flex items-center justify-center px-2 py-0.5 text-xs font-bold leading-none text-white bg-red-500 rounded-full">{this.props.unread_messages}</span>
															)}
														</Link>
													</div>
												)
											}
										})}
                  					</nav>
               					</div>
								<div className="flex-shrink-0 border-t border-gray-700 p-4">
									<div className="flex items-center gap-3 mb-3">
										{userAvatar}
										<div className="flex-1 min-w-0">
											<p className="text-sm font-medium text-white truncate">{user.firstname} {user.lastname}</p>
											<p className="text-xs text-gray-400 truncate">{user.email}</p>
										</div>
									</div>
									<div className="space-y-1">
										<Link
											to="/parametres"
											className="block px-2 py-1.5 text-sm text-gray-300 hover:text-white hover:bg-gray-700 rounded-md transition-colors"
										>
											Mon compte
										</Link>
										<button
											onClick={this.props.updateUser.bind(this, null)}
											className="block w-full text-left px-2 py-1.5 text-sm text-gray-300 hover:text-white hover:bg-gray-700 rounded-md transition-colors"
										>
											Se déconnecter
										</button>
									</div>
								</div>
							</div>
						</Transition.Child>
						<div className="flex-shrink-0 w-14" aria-hidden="true">
							{/* Dummy element to force sidebar to shrink to fit close icon */}
						</div>
					</Dialog>
				</Transition.Root>

				{/* Static sidebar for desktop */}
				{!this.props.collapsed && (
				<div className="hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0 z-20" style={{ top: this.props.banner_height || 0 }}>
					<div className="flex-1 flex flex-col min-h-0 bg-gray-800">
						<div className="flex items-center justify-between h-16 flex-shrink-0 px-4 bg-gray-900">
							<img
								className="h-16 w-auto"
								src={logo}
								alt="pocketcamp"
							/>
							<button
								onClick={this.props.onToggleCollapse}
								className="p-1.5 rounded-lg text-gray-400 hover:text-white hover:bg-gray-700 transition-colors"
								style={{ backgroundImage: 'none', backgroundColor: 'transparent' }}
								title="Masquer le menu"
							>
								<ChevronLeftIcon className="h-5 w-5" />
							</button>
						</div>
						<div className="flex-1 flex flex-col overflow-y-auto" style={{ backgroundColor: '#1F2937'}}>
              				<nav className="flex-1 px-2 py-4 space-y-1 shadow-none" style={{ backgroundColor: '#1F2937'}}>
                				{this.state.navigation.map((item, navigation_k) => {
									let collapse = null
									if (item.collapse)
									{
										let collapseStyle = "hidden"
										if (this.state.navigation[navigation_k].display === true)
											collapseStyle = "block"
										collapse = this.state.navigation[navigation_k].collapse.map((elem, collapse_k) => {
											return (
												<div key={collapse_k} className={collapseStyle}>
													<Link
														to={elem.path}
														className={this.classNames(		
														elem.current ? 'bg-gray-900 text-white block' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
														'block group flex items-center pl-12 py-2 text-base font-medium rounded-md'
														)}
													>
														{elem.collapseName}
													</Link>
												</div>
											)
										})
										return (
											<div key={navigation_k}>
												<li
													onClick={this.handleCollapse.bind(this, navigation_k)}
													className={this.classNames(		
													item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
													'group flex relative items-center px-3 py-2 text-base font-medium rounded-md'
													)}
												>
													<item.icon
														className={this.classNames(
															item.current  ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-300',
															'mr-3 flex-shrink-0 h-6 w-6'
														)}
														aria-hidden="true"
													/>
														{item.name}
													<svg
														className={this.classNames(
															(collapseStyle === "block") ? 'text-gray-400 rotate-90' : 'text-gray-300',
															'ml-3 flex-shrink-0 absolute right-4 h-5 w-5 transform group-hover:text-gray-400 transition-colors ease-in-out duration-150'
															)}
															viewBox="0 0 20 20"
															aria-hidden="true"
													>
														<path d="M6 6L14 10L6 14V6Z" fill="currentColor" />
													</svg>
												</li>
												{collapse}
											</div>
										)
									}
									else
									{
										return (
											<div key={navigation_k}>
												<Link
													to={item.path}
													className={this.classNames(		
													item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white',
													'group flex items-center px-3 py-2 text-base font-medium rounded-md'
													)}
												>
													<item.icon
														className={this.classNames(
															item.current ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-300',
															'mr-3 flex-shrink-0 h-6 w-6'
														)}
														aria-hidden="true"
													/>
													{item.name}
													{item.name === 'Messagerie' && this.props.unread_messages > 0 && (
														<span className="ml-auto inline-flex items-center justify-center px-2 py-0.5 text-xs font-bold leading-none text-white bg-red-500 rounded-full">{this.props.unread_messages}</span>
													)}
												</Link>
											</div>
										)
									}
								})}
              				</nav>
            			</div>
					<div className="flex-shrink-0 border-t border-gray-700 p-4">
						<div className="flex items-center gap-3 mb-3">
							{userAvatar}
							<div className="flex-1 min-w-0">
								<p className="text-sm font-medium text-white truncate">{user.firstname} {user.lastname}</p>
								<p className="text-xs text-gray-400 truncate">{user.email}</p>
							</div>
						</div>
						<div className="space-y-1">
							<Link
								to="/parametres"
								className="block px-2 py-1.5 text-sm text-gray-300 hover:text-white hover:bg-gray-700 rounded-md transition-colors"
							>
								Mon compte
							</Link>
							<button
								onClick={this.props.updateUser.bind(this, null)}
								className="block w-full text-left px-2 py-1.5 text-sm text-gray-300 hover:text-white hover:bg-gray-700 rounded-md transition-colors"
							>
								Se déconnecter
							</button>
						</div>
					</div>
				</div>
				</div>
				)}
				{/* Floating re-open button when collapsed (desktop) */}
				{this.props.collapsed && (
					<button
						onClick={this.props.onToggleCollapse}
						className="hidden lg:flex fixed z-30 left-4 items-center justify-center w-9 h-9 bg-gray-800 hover:bg-gray-700 text-white rounded-lg shadow-lg transition-colors"
						style={{ backgroundImage: 'none', top: (this.props.banner_height || 0) + 16 }}
						title="Ouvrir le menu"
					>
						<ChevronRightIcon className="h-5 w-5" />
					</button>
				)}
				{/* Floating open button for mobile/tablet (< lg) */}
				{!this.state.sidebarOpen && (
					<button
						onClick={this.setSidebarOpen}
						className={`${this.props.hideToggle ? 'hidden md:flex' : 'flex'} lg:hidden fixed z-30 left-4 items-center justify-center w-9 h-9 bg-gray-800 hover:bg-gray-700 text-white rounded-lg shadow-lg transition-colors`}
						style={{ backgroundImage: 'none', top: (this.props.banner_height || 0) + 16 }}
						title="Ouvrir le menu"
					>
						<ChevronRightIcon className="h-5 w-5" />
					</button>
				)}
			</div>
		)
	}
}

export default SidebarTailwind